import { render } from "./HeroiconsOutlineMoon.vue?vue&type=template&id=174f5433"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMoon.vue"]])

export default __exports__